<div>
  <div
    [class.flex-row]="layout === 'horizontal'"
    [class.flex-col]="layout === 'vertical'"
    class="msg-flex mt-sm flex rounded-3 border"
    [class]="colour + ' ' + layout"
  >
    <div class="flex flex-row items-baseline px-md py-xs" [class.md:p-lg]="layout === 'horizontal'">
      @if (!!icon) {
        <fa-icon [icon]="icon!" class="w-full text-base text-white md:text-lg"></fa-icon>
      }
    </div>
    <div class="flex w-full min-w-0 flex-col">
      <div
        class="msg-body flex grow flex-col justify-center bg-white p-md"
        [class.rounded-br-3]="!hasFooter"
        [class.rounded-bl-3]="layout === 'vertical' && !hasFooter"
        [class.rounded-tr-3]="layout === 'horizontal'"
      >
        @if (!!title) {
          <div class="mb-2xs heading-base">{{ title }}</div>
        }
        <div class="text-sm text-president-500">
          <ng-content></ng-content>
        </div>
      </div>
      @if (hasFooter) {
        <div class="msg-footer rounded-br-3 bg-white pb-sm" [class.rounded-bl-3]="layout === 'vertical'">
          <ng-content select="cft-message-footer"></ng-content>
        </div>
      }
    </div>
  </div>
</div>
